module.exports = __webpack_public_path__ + "img/booking_aplikasi_&_marketplace.c387b78e.svg";